
import Vue from "vue";
import { mapState } from "vuex";
import { UI } from "@/store/ui";
import { IRootState } from "@/store/types";
import {
  ReferenceDataType,
  IReferenceDataItem
} from "@/store/referenceData/types";
import { REFERENCE_DATA } from "@/store/referenceData";

export default Vue.extend({
  props: {
    value: {
      type: [String, Number, Array]
    },
    rules: {},
    name: {
      type: String
    },
    label: {
      type: String,
      required: true
    },
    clearable: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      required: true,
      validator(value: number) {
        return Object.values(ReferenceDataType).includes(value);
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showAddLink: {
      type: Boolean,
      default: true
    }
  },
  data(): any {
    return {
      showDialog: false
    };
  },
  computed: {
    $rootState(): IRootState {
      return this.$store.state;
    },
    ...mapState({
      isLoading: (state: IRootState) => state.referenceData.isLoading
    }),
    data(): any {
      return (
        this.type &&
        this.$rootState.referenceData.data &&
        this.$rootState.referenceData.data[this.type]
      );
    },
    items(): any {
      return (
        this.data &&
        this.data.items &&
        this.data.items.map((item: any) => {
          return {
            description: item.description,
            id: String(item.id)
          };
        })
      );
    },
    defaultValue(): string {
      return this.data && this.data.defaultValue;
    }
  },
  watch: {
    defaultValue: {
      immediate: true,
      handler(value) {
        if (!this.value && value) {
          this.$emit("input", value);
        }

        // handle the case when this.value is an array
        if (Array.isArray(this.value) && !this.value[0] && value) {
          this.$emit("input", [value]);
        }
      }
    }
  },
  methods: {
    openDialog() {
      if (!this.disabled) {
        this.showDialog = true;
      }
    },
    onChange(value: string | string[]) {
      this.$emit("input", value);
    },
    onReferenceDataCreated(value: IReferenceDataItem) {
      const createdItem = this.items.find((item: any) => item.description === value.description);

      if (createdItem) {
        // If multiple, the value should be an array
        if (this.multiple) {
          if (this.value && Array.isArray(this.value)) {
            this.$emit("input", [...this.value, createdItem.id]);
          } else {
            this.$emit("input", [createdItem.id]);
          }
        } else {
          this.$emit("input", createdItem.id);
        }
      }
    }
  }
});
